import { useState } from 'react';
import { Link } from 'react-router-dom';

const SOCIALS = [
  {
    label: 'X (Twitter)',
    href: 'https://twitter.com/nigeriacsindex',
    path: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.451-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644z',
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/nigeriacsindex',
    path: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z',
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/nigeriacsindex',
    path: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z',
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/nigeriacsindex',
    path: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 110-4.124 2.062 2.062 0 010 4.124zM7.119 20.452H3.555V9h3.564v11.452z',
  },
];

const WebsiteFooter = () => {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);

  const subscribe = (e) => {
    e.preventDefault();
    if (!email.includes('@')) return;
    setDone(true);
  };

  const toTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="nx-footer nx-footer-modern">
      <div className="nx-foot-top">
        <div className="nx-foot-statement">
          <div className="nx-foot-kicker">The national record of service</div>
          <div className="nx-foot-word" aria-hidden="true">
            Your experience is data<span>.</span>
          </div>
        </div>
        <div className="nx-foot-news">
          <h3>Get the index releases first.</h3>
          <p>Quarterly scores, sector rankings and what moved. No spam.</p>
          {done ? (
            <div className="nx-news-done">Thank you. You are on the list.</div>
          ) : (
            <form className="nx-news-form" onSubmit={subscribe}>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                aria-label="Email address"
              />
              <button type="submit">Subscribe</button>
            </form>
          )}
        </div>
      </div>

      <div className="nx-foot-grid">
        <div className="nx-foot-brand">
          <div className="nx-foot-logo">
            <img src={process.env.PUBLIC_URL + '/logo.png'} alt="Nigeria CSI" />
            <span>
              <b>Nigeria CSI</b>
              <i>Customer Service Index</i>
            </span>
          </div>
          <p>
            An independent, objective record of customer satisfaction
            across twelve sectors of Nigerian life.
          </p>
          <div className="nx-foot-social">
            {SOCIALS.map((s) => (
              <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label} title={s.label}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d={s.path} />
                </svg>
              </a>
            ))}
          </div>
        </div>

        <div className="nx-foot-col">
          <h4>Index</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/sectors">Sectors</Link></li>
            <li><Link to="/reports">Reports</Link></li>
            <li><Link to="/about">About the index</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="nx-foot-col">
          <h4>Participate</h4>
          <ul>
            <li><Link to="/survey/">Take the survey</Link></li>
            <li><Link to="/sectors">Sector detail</Link></li>
            <li><Link to="/about">Assessment framework</Link></li>
          </ul>
        </div>

        <div className="nx-foot-col">
          <h4>Office</h4>
          <ul className="nx-foot-contact">
            <li>Lagos, Nigeria</li>
            <li><a href="mailto:service@thewaacsp.com">service@thewaacsp.com</a></li>
            <li><a href="mailto:Nigeriacsindex@gmail.com">Nigeriacsindex@gmail.com</a></li>
            <li className="nx-foot-partners">
              <a href="https://thewaacsp.com" target="_blank" rel="noopener noreferrer">WAACSP</a>
              <span> · </span>
              <a href="https://adinortey.com" target="_blank" rel="noopener noreferrer">Nextera Labs</a>
            </li>
          </ul>
          <button className="nx-to-top" onClick={toTop} type="button">
            Back to top ↑
          </button>
        </div>
      </div>

      <div className="nx-foot-bottom">
        <span>© {new Date().getFullYear()} Nigeria Customer Service Index. All rights reserved.</span>
        <span className="nx-foot-legal">
          <Link to="/about">Methodology</Link>
          <Link to="/contact">Privacy</Link>
        </span>
      </div>
    </footer>
  );
};

export default WebsiteFooter;
